{
  "paymentInformation": "Payment details",
  "paymentReferences": "References and account numbers",
  "paymentHistory": "Payment history",
  "currentMonth": "Current month",
  "invoices": "Invoices",
  "itemisation": "Invoice itemisation",
  "payer": "Payer",
  "dueDate": "Due date",
  "sum": "Sum",
  "sumTotal": "Total",
  "remittances": "Fees",
  "refund": "Refund",
  "transfer": "Transfer",
  "withheldFrom": {
    "securityDeposit": "Withheld from security deposit",
    "depositVoucher": "Withheld from deposit voucher",
    "rooFee": "Withheld from right-of-occupancy payment"
  },
  "paidDate": "Paid",
  "noTargets": "No invoice lines",
  "creditNote": "Credit",
  "noRemittances": "No charges",
  "arrearTotal": "Total arrear",
  "advanceTotal": "Total advance",
  "arrearTotalForMonth": "Amount due {{month}}",
  "advanceTotalForMonth": "Advance {{month}}",
  "neutralTotal": "Total",
  "saldo": "Balance",
  "paymentTypeCategory": {
    "chargesForUtilities": "Compensation for usage",
    "rent": "Rent",
    "residenceCharge": "Maintenance charge",
    "rightOfOccupancyDeposit": "Right-of-occupancy payment",
    "securityDeposit": "Security deposit",
    "interest": "Interest",
    "generic": "General",
    "rightOfOccupancyNewDevelopmentDeposit": "Right-of-occupancy fee for new builds"
  },
  "paymentsBeneficiary": "Beneficiary",
  "referenceNumber": "Invoice reference number",
  "noAccountData": "Bank account details are missing",
  "errors": {
    "failedToLoadPaymentInfo": "Payment information failed to load",
    "failedToLoadPaymentHistory": "Payment history failed to load",
    "paymentsAccessDenied": "You do not have sufficient permissions to view the payment information of this agreement."
  }
}
